module.exports = __webpack_public_path__ + "ipetbooking-landing/img/interface06@1.879ad4c7.png";